const { SINGLE_MARKET_EXECUTIVE_REQUEST, SINGLE_MARKET_EXECUTIVE_SUCCESS, SINGLE_MARKET_EXECUTIVE_FAILED, SINGLE_MARKET_EXECUTIVE_RESET } = require("app/utils/constants/MarketExecutiveConstant")

const INTI_STATE = {
    loading: false,
    singleMarketExecutive: {},
    error: false,
    errorMessage: null
}

export const marketExecutiveReducer = (state = INTI_STATE, action) => {
    switch (action.type) {
        //single market executive
        case SINGLE_MARKET_EXECUTIVE_REQUEST:
            return {
                ...state, loading: true
            }
        case SINGLE_MARKET_EXECUTIVE_SUCCESS:
            return {
                ...state,
                singleMarketExecutive: action.payload.data,
                loading: false
            }
        case SINGLE_MARKET_EXECUTIVE_FAILED:
            return {
                singleMarketExecutive: {},
                error: true,
                errorMessage: action.payload,
                loading: false
            }
        case SINGLE_MARKET_EXECUTIVE_RESET:
            return {
                loading: false,
                singleMarketExecutive: {},
                error: false,
                errorMessage: null
            }
        default:
            return state
    }
}